module.exports = __webpack_public_path__ + "img/m.648f7c9d.webp";